import Dexie from "dexie";

export const db = new Dexie('yumyIMDB')
db.version(1).stores({
	contacts: 'id, age, acatar, country, displayName, gender, index, isFriend, kefuid, language, lastConternt, lastSendTime, onlineStatus, uid, unread, userInfo, userid, zhuboInfo, zhuboid',
})

